import Feature from "ol/Feature";
import Circle from "ol/geom/Circle";
import LineString from "ol/geom/LineString";
import Point from "ol/geom/Point";
import Text from "ol/style/Text";
import Vector from "ol/layer/Vector";
import SourceVector from "ol/source/Vector";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import proj4 from "proj4";

function getLatitudeCircle(fromProj: string, toProj: string, latitude: number) {
  return new Circle([0, 0], proj4(fromProj, toProj, [0, latitude])[1]);
}

function getLongitudeLine(
  fromProj: string,
  toProj: string,
  centerLat: number,
  outerLat: number,
  longitude: number
) {
  let start = proj4(fromProj, toProj, [longitude, centerLat]);
  let end = proj4(fromProj, toProj, [longitude, outerLat]);
  return new LineString([start, end]);
}

function getTextStyle(labelText: string, placement: string) {   // Label Text object.
  return new Text({
    text: labelText,
    placement: placement,
    font: '12px Calibri,sans-serif',
    textBaseline: 'middle',
    fill: new Fill({
      color: 'rgba(0,0,0,1)'
    }),
    stroke: new Stroke({
      color: 'rgba(255,255,255,1)',
      width: 3
    })
  });
}

function getGraticuleSourceVectorLayer(
  centerLat: number,
  outerLat: number,
  latitudes: number[],
  fromProj: string,
  toProj: string
) {
  let source = new SourceVector();
  for (let lat of latitudes) {  // Add latitude lines + label points.
    let circle = getLatitudeCircle(fromProj, toProj, lat);
    source.addFeature(
      new Feature({
        name: lat.toString(),
        geometry: circle,
      })
    );
    source.addFeature(
      new Feature({
        name: lat.toString() + "°",
        geometry: new Point(proj4(fromProj, toProj, [0, lat])),
      })
    );
  }
  for (let lon = 0; lon < 360; lon += 45) { // Add longitude lines + label points.
    let line = getLongitudeLine(fromProj, toProj, centerLat, outerLat, lon);
    let label = lon.toString()
    if (lon > 180){
      label = (lon - 360).toString()  // Fix for 0 to 180 and 0 to -180 lon labels. 
    }
    source.addFeature(
      new Feature({
        name: label,
        geometry: line,
      })
    );
    source.addFeature(
      new Feature({
        name: label + "°",
        geometry: new Point(proj4(fromProj, toProj, [lon, outerLat - (outerLat/Math.abs(outerLat)*1.3)])),
      })
    );
  }
  var gs = new Style();
  gs.setFill(new Fill({ color: "rgba(255,255,255,0)" }));
  gs.setStroke(
    new Stroke({
      color: "rgba(255,120,0,0.9)",
      width: 1,
    })
  );

  let graticuleLayer = new Vector({
    source: source,
    renderMode: "vector",
    renderBuffer: 10000,
    style: function (feature) {
      if (feature.getGeometry().getType() === "Point") {
        gs.setText(getTextStyle(feature.get("name"), "point"));
      } else {
        gs.setText(null);
      }
      return gs;
    },
  });

  return graticuleLayer;
}

export { getGraticuleSourceVectorLayer };
